import Vue from "vue";
import settings from "../settings";
const COOKIE_TOKEN_KEY = "token";

export let commonMixin = {
  methods: {
    LogOut () {
      Vue.$cookies.remove(COOKIE_TOKEN_KEY);
    },
    getTokenFromCookies () {
      let token = Vue.$cookies.get(COOKIE_TOKEN_KEY);
      if (!token) {
        window.location.href = settings.auth_url;
      }
      return token
    },
    get_current_month (deadline) {
      let fist_space = deadline.indexOf(" ")
      let month = deadline.substr(0, fist_space)
      if (month == "January") return "Декабрь"
      if (month == "February") return "Январь"
      if (month == "March") return "Февраль"
      if (month == "April") return "Март"
      if (month == "May") return "Апрель"
      if (month == "June") return "Май"
      if (month == "July") return "Июнь"
      if (month == "August") return "Июль"
      if (month == "September") return "Август"
      if (month == "October") return "Сентябрь"
      if (month == "November") return "Октябрь"
      if (month == "December") return "Ноябрь"
    },
    required (v) {
      return !!v || 'Обязательное поле.'
    },
    required6 (v) {
      if (v) {
        return v.length == 6 || 'Код должен содержать 6 символов'
      }
      return true
    },
    counter50 (v) {
      if (v) {
        return v.length <= 50 || 'Максимум 50 символов'
      }
      return true
    },
    counter30 (v) {
      if (v) {
        return v.length <= 30 || 'Максимум 30 символов'
      }
      return true
    },
    counter20 (v) {
      if (v) {
        return v.length <= 20 || 'Максимум 20 символов'
      }
      return true
    },
    min (v) {
      if (v) {
        return v.length >= 8 || 'Минимум 8 символов'
      }
      return true
    },
    emailRules (v) {
      if (v) {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (v.length > 50) {
          this.email_hint = []
          return 'Максимум 50 символов'
        }
        if (!pattern.test(v)) {
          this.email_hint = []
          return 'Некорректный E-mail.'
        }
      } else {
        this.email_hint = []
        return 'Обязательное поле.'
      }
      return true
    },
    word_num_cases (quantity, one_wrd, two_four, many) {
      if (quantity || quantity === 0) {
        let string = quantity.toString()
        let last_symb = string[string.length - 1]
        if (quantity > 9 && quantity < 20) {
          return many
        }
        if (last_symb == "1") {
          return one_wrd
        } else if (last_symb == "2" || last_symb == "3" || last_symb == "4") {
          return two_four
        }
        return many
      }
    }
  }
};
